import { Localization } from '../../services/localization/localization.types';
import { isBrowser } from './isBrowser';

export const getGlobalObject = () => {
    return isBrowser()
        ? (window as unknown as typeof window & Localization)
        : (global as unknown as typeof globalThis & Localization);
};
